<template>
	<div class="note-drafts" v-if="!state.isLoading">
		<div
			:style="{ columnGap: '1rem' }"
			v-for="(draft, index) in data.drafts"
			:key="index"
			class="note-draft text-white"
		>
			<a @click="confirmDelete(draft.journal_id)">
				<font-awesome-icon
					icon="fa-solid fa-xmark"
					class="d-flex"
					height="1rem"
					color="white"
				></font-awesome-icon>
			</a>
			<a @click="openModal(draft.journal_id)">
				<h5 v-if="draft.journal_id">
					{{ draft.student?.fname }} {{ draft.student?.lname }} kl.
					{{ format(new Date(draft.joural_date), "HH:mm") }}
				</h5>
			</a>
			<a @click="openModal(draft.journal_id)">
				<font-awesome-icon
					icon="fa-solid fa-arrow-up-right-from-square"
					class="d-flex"
					height="1rem"
					color="white"
				></font-awesome-icon>
			</a>
		</div>
	</div>
	<put-modal
		:data="data"
		:state="state"
		:isPutModal="state.isPutModal"
		@close="closeModal"
		@update-drafts="fetchDrafts"
		:store="authStore"
		v-if="state.isPutModal"
	>
	</put-modal>
</template>
<script setup>
import { terms } from "@helpers/TermHelper";
import StudentMetaService from "@services/StudentMetaService";
import { format, setDefaultOptions } from "date-fns";
import da from "date-fns/locale/da";
import Swal from "sweetalert2";
import { onMounted, ref } from "vue";
import JournalService from "../../services/JournalService";
import putModal from "./modals/putModal.vue";
import { useAuthStore } from "../../../newSrc/stores/authStore";
const authStore = useAuthStore();
setDefaultOptions({ locale: da });

const studentMetaService = new StudentMetaService();
const journalService = new JournalService();

const journalBox = "student_box_5";

const props = defineProps(["studentId"]);

const data = ref({
	note: {},
	drafts: Array,
	terms: {},
	studentId: props?.studentId,
});

const state = ref({
	isPutModal: false,
	isJournalBox: Number,
	isLoading: true,
});

const openModal = async (id) => {
	data.value.note = await journalService
		.get(id)
		.then((response) => response.data);
	console.log(data.value.note);
	state.value.isPutModal = true;
};

const confirmDelete = (id) => {
	new Swal({
		title: "Du er i gang med at slette en kladde",
		text: "Er du sikker?",
		icon: "error",
		showCancelButton: true,
		reverseButtons: true,
		cancelButtonText: "Annuller",
		confirmButtonText: "Slet",
		customClass: {
			confirmButton: "btn-deletion",
			cancelButton: "btn-bluedesign",
		},
	}).then((result) => {
		if (result.isConfirmed) {
			deleteDraft(id);
		}
	});
};

const deleteDraft = async (id) => {
	await journalService.deleteDraft(id).then(() => {
		Swal.fire({
			title: "",
			icon: "success",
			text: "Kladden er slettet",
			timer: 2000,
			showConfirmButton: false,
		});
		fetchDrafts();
	});
};

const closeModal = async (id) => {
	state.value.isPutModal = false;
	emit("close", id);
};

const fetchDrafts = async () => {
	data.value.drafts = await journalService.getAllDrafts().then((response) => {
		emit("draftsChanged", response.data.length);
		return response.data;
	});
};

const getIsJournalBox = async () => {
	state.value.isJournalBox = await studentMetaService
		.getBox(journalBox)
		.then((response) => response);
};

const fetchTerms = async () => {
	data.value.terms = await terms();
};

const fetchAll = async () => {
	await Promise.all([fetchDrafts(), getIsJournalBox(), fetchTerms()]).then(
		() => (state.value.isLoading = false),
	);
};
onMounted(() => {
	fetchAll();
});
const emit = defineEmits("close, draftsChanged");
defineExpose({ fetchDrafts });
</script>
<style>
@import url("/frontend/public/css/app.css");
</style>
